import { routing } from "@/i18n/routing";

export function splitOutLocale(href: string): string {
  for (const locale of routing.locales) {
    if (href.startsWith(`/${locale}/`)) {
      return href.replace(`/${locale}/`, "/");
    }
  }

  return href;
}
